import type { ChatUser } from 'models';
import { Button, EntitySnippet, MinusCircleIcon } from 'ui';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { UserLink } from 'features/users/components/user-link';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { UserPopover } from 'features/users/components/user-popover';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependencies
import { useGetNodeUserAvatar, useGetUserFullNameWithFallback } from 'features/users/hooks';
import { useGetListUserDisplayName } from '../../../../../hooks';

type P = {
  canRemove: boolean;
  member: ChatUser;
  onRemove: (member: ChatUser) => void;
};

const MEMBER_AVATAR_SIZE = 32;

const ChatGroupInfoMemberItem = ({ canRemove, member, onRemove }: P) => {
  const getUserFullNameWithFallback = useGetUserFullNameWithFallback();
  const getNodeUserAvatar = useGetNodeUserAvatar();
  const getListUserDisplayName = useGetListUserDisplayName();
  const fullName = getUserFullNameWithFallback(member);
  const displayName = getListUserDisplayName(member.id, fullName);
  const profilePhoto = getNodeUserAvatar({ userId: member.id });

  return (
    <EntitySnippet
      avatarProps={{
        photo: profilePhoto,
        size: MEMBER_AVATAR_SIZE,
      }}
      descriptionProps={member.email ? { children: member.email } : undefined}
      extra={
        canRemove ? (
          <Button
            icon={<MinusCircleIcon type="error" />}
            onClick={() => {
              onRemove(member);
            }}
            type="link-secondary"
          />
        ) : undefined
      }
      titleProps={{
        children: displayName,
        ellipsis: true,
        weight: 'medium',
      }}
      wrapAvatar={(avatar) => (
        <UserPopover fallback={{ ...member, profilePhoto }} userId={member.id}>
          <UserLink effects={{ radius: false }} userId={member.id}>
            {avatar}
          </UserLink>
        </UserPopover>
      )}
      wrapTitle={(title) => (
        <UserPopover fallback={{ ...member, profilePhoto }} userId={member.id}>
          <UserLink userId={member.id}>{title}</UserLink>
        </UserPopover>
      )}
    />
  );
};

export default ChatGroupInfoMemberItem;
